import React, { useRef } from "react";
import Editor, { EditorProvider } from "react-simple-wysiwyg";

const MAX_WORDS = 300;

const CustomeEditor = ({
  onChange,
  value,
  name,
  businessListDisable = false,
  isReadOnly = false,
  onFocus,
  onCursorChange,
}) => {
  const isDisabled = businessListDisable || isReadOnly;
  const editorRef = useRef(null);

  const getWordCount = (html) => {
    const text = html.replace(/<[^>]*>/g, " "); // remove HTML tags
    const words = text.trim().split(/\s+/).filter(Boolean);
    return words.length;
  };

  const handleCursor = () => {
    if (!onCursorChange) return;

    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return;

    const range = sel.getRangeAt(0);

    onCursorChange({
      name,
      range,
    });
  };

  const handleChange = (e) => {
    if (isDisabled) return;

    const html = e.target.value;
    const wordCount = getWordCount(html);

    if (wordCount > MAX_WORDS) {
      return; // block extra words
    }

    if (onChange) {
      onChange(e);
      setTimeout(() => handleCursor(), 0);
    }
  };

  const handleFocus = () => {
    if (!isDisabled && onFocus) {
      onFocus();
    }
    handleCursor();
  };

  const wordCount = getWordCount(value || "");

  return (
    <EditorProvider>
      <Editor
        ref={editorRef}
        value={value || ""}
        onChange={handleChange}
        onFocus={handleFocus}
        onSelect={handleCursor}
        name={name}
        disabled={isDisabled}
        style={{
          backgroundColor: isDisabled ? "#f5f5f5" : "white",
          cursor: isDisabled ? "not-allowed" : "text",
          minHeight: "180px",
          padding: "10px",
        }}
      />
      <div style={{ textAlign: "right", fontSize: "12px", marginTop: "5px" }}>
        {wordCount}/{MAX_WORDS} words
      </div>
    </EditorProvider>
  );
};

export default CustomeEditor;